const changeLogColumns = {
  timestampChange: {
    key: 'timestampChange',
    label: 'timestampChange',
    type: 'datetimeseconds',
    sortable: 'custom',
    minWidth: 120,
  },
  hostname: {
    key: 'hostname',
    label: 'hostname',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
  },
  ipAddress: {
    key: 'ipAddress',
    label: 'ipAddress',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
  },
  userName: {
    key: 'userName',
    label: 'userName',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
  },
  entityName: {
    key: 'entityName',
    label: 'entityName',
    type: 'enum',
    enum: 'entities',
    sortable: 'custom',
    minWidth: 120,
  },
  labSampleCode: {
    key: 'labSampleCode',
    label: 'labSampleId',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  analysisCode: {
    key: 'analysisCode',
    label: 'analysisId',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  analysisDescription: {
    key: 'analysisDescription',
    label: 'analysisDescriptionFull',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  articleCodes: {
    key: 'articleCodes',
    label: 'articleCodes',
    type: 'text',
    sortable: false,
    minWidth: 120,
    ellipsis: true,
  },
  articleDescriptions: {
    key: 'articleDescriptions',
    label: 'articleDescriptions',
    type: 'text',
    sortable: false,
    minWidth: 120,
    ellipsis: true,
  },
  lot: {
    key: 'lot',
    label: 'lot',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
  },
  changeType: {
    key: 'changeType',
    label: 'changeType',
    type: 'enum',
    enum: 'changeTypes',
    sortable: 'custom',
    minWidth: 120,
  },
  source: {
    key: 'source',
    label: 'source',
    type: 'enum',
    enum: 'sources',
    sortable: 'custom',
    minWidth: 120,
    permissions: ['advancedRevisionView'],
  },
  reportCode: {
    key: 'reportCode',
    label: 'reportCode',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
    permissions: ['advancedRevisionView'],
  },
  reportStatus: {
    key: 'reportStatus',
    label: 'reportStatus',
    type: 'enum',
    enum: 'sampleReportStatuses',
    sortable: 'custom',
    minWidth: 120,
    permissions: ['advancedRevisionView'],
  },
  revision: {
    key: 'revision',
    label: 'revision',
    type: 'text',
    sortable: 'custom',
    minWidth: 80,
    permissions: ['advancedRevisionView'],
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 200,
    buttons: [
      {
        name: 'viewChangelogDetails',
        icon: 'fas fa-eye',
        permissions: ['changelogView'],
        showCondition: (row) => row.entityName !== 'UserSessionLogin',
      },
    ],
  },
};

export default changeLogColumns;
